//Third party components
import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

// Shared components
import { LineLoader, PamLayoutGrid, Modal } from '@timmons-group/shared-react-components';

// Hooks
import { useGet, useAuth } from '@timmons-group/shared-react-components/hooks';
import { useLayout } from '../../hooks/useLayout';
import { hasPermission } from '../../helpers';
import { useNavigate } from 'react-router-dom';
import { ACLS } from '../../constants';

// Constants
const ModalMode = {
  Edit: 'EDIT',
  // Delete: 'DELETE',
};

const ModalAction = {
  Edit: 'EDIT',
  // Delete: 'DELETE',
  Close: 'CLOSE',
  // Reset: 'RESET',
};

// Reducers
const initialModalState = {
  modalIsOpen: false,
  modalTitle: '',
  modalText: '',
  okLabel: 'OK',
  modalMode: null,
  rowData: null,
};

const modalReducer = (state, action) => {
  const rowData = { ...action?.payload?.rowData };
  switch (action.type) {
    case ModalAction.Edit:
      return { modalIsOpen: true, modalText: `NOT IMPLEMENTED - Edit ${rowData?.name}`, modalMode: ModalMode.Edit, rowData };
    // case ModalAction.Delete:
    //   return { modalTitle: 'Confirm Delete', modalIsOpen: true, modalText: `Are you sure you want to permanently delete this Recipient from "${action?.payload?.  recipient???  .name}"?`, modalMode: ModalMode.Delete, rowData, okLabel: 'Delete Recipient' };
    case ModalAction.Close:
      return { ...state, modalIsOpen: false };
    case ModalAction.Reset:
      return { ...initialModalState };
    default:
      throw new Error('This mode is not supported.');
  }
}

const IndividualRecipientsGrid = () => {
  const [recipients, loading] = useGet('api/recipient/all', [])
  const [layout, layoutLoading] = useLayout('recipient', 'recipientList');
  const [modalState, modalDispatch] = React.useReducer(modalReducer, initialModalState);
  const { authState } = useAuth();

  // props.acl is a backdoor to allow storybook stories to pass in acls
  const acl = authState?.user?.acl;
  const nav = useNavigate();

  const handleEditClick = (row) => {
    nav(`/recipients/editRecipient/${row.id}`);
  }

  let actionList = [];
  if (hasPermission(ACLS.EDIT_RECIP, acl)) {
    actionList.push({
      label: 'Edit',
      order: 0,
      clickHandler: handleEditClick
    });
  }

  const actionData = [{
    order: 0,
    actionList,
    label: 'Actions',
  }];

  const handleModalAffirmative = () => {
    try {
      modalDispatch({ type: ModalAction.Close });

      switch (modalState.modalMode) {
        // case ModalMode.Delete:
        //   requestDeleteRecipient(modalState.rowData?.recipientID);
        //   break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);
    } finally {
      // Ensure that we clear the data
      modalDispatch({ type: ModalAction.Reset });
    }
  }

  const handleModalCancel = () => {
    modalDispatch({ type: ModalAction.Reset });
  }

  const renderRecipients = () => {
    if (loading) {
      return <LineLoader message="Loading Recipients..." color="secondary" />;
    }

    if (!recipients || !recipients.length) {
      return <p>No Recipients found</p>;
    }

    return loading || layoutLoading ?
      (<Box>
        <LineLoader message="Loading All Recipients..." color="secondary" />
      </Box>)
      :
      (<Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        mt={2}
        minHeight="500px"
        width="100%"
      >
        <PamLayoutGrid
          actions={actionData}
          data={recipients}
          getRowId={(row) => row.streamID}
          initialSortColumn={'lastName'}
          initialSortDirection={'asc'}
          layout={layout}
          autoHeight
          disableSelectionOnClick
          density="compact"
        />
      </Box>)
  };

  return (
    <>
      {renderRecipients()}
      <Modal
        okLabel={modalState.okLabel || 'Confirm'}
        cancelLabel="Cancel"
        title={modalState.modalTitle}
        onOk={handleModalAffirmative}
        onCancel={handleModalCancel}
        handleClose={handleModalCancel}
        showX={true}
        open={modalState.modalIsOpen}
        hideActions={false}
        hideCancel={false}
      >
        <Typography gutterBottom>
          {modalState.modalText}
        </Typography>
      </Modal>
    </>
  );
}

export default IndividualRecipientsGrid;
